import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import { K } from "./apiServiceI18n";

const HEADER_BG = "#5f6878";

const actionButtonSx = {
  bgcolor: HEADER_BG,
  color: "#fff",
  textTransform: "none",
  boxShadow: "none",
  minWidth: 100,
  "&:hover": { bgcolor: "#4d5563", boxShadow: "none" },
};

/**
 * “Do you want to Translate Data now?” — shown after Get Data Apply.
 */
export default function TranslateDataPromptDialog({ open, onClose, onYes, onNo }) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      className="dialog-top"
      slotProps={{
        root: { sx: { zIndex: (theme) => theme.zIndex.modal + 2 } },
      }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          py: 4,
          px: 3,
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            border: "2px solid",
            borderColor: "grey.400",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "grey.600",
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 40 }} />
        </Box>
        <Typography variant="h6" fontWeight={700}>
          {t(K.API_SVC_OPTIONAL_STEP)}
        </Typography>
        <Typography variant="body1">{t(K.API_SVC_TRANSLATE_NOW_PROMPT)}</Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: 1, pb: 3 }}>
        <Button variant="contained" onClick={onYes} sx={actionButtonSx}>
          {t(K.BTN_YES)}
        </Button>
        <Button variant="outlined" onClick={onNo} sx={{ textTransform: "none", minWidth: 100 }}>
          {t(K.BTN_NO)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
